












import Vue from 'vue';
import { DisplayToggleOffset } from '@/utils';

export default Vue.extend({
  name: 'ScrollToTop',
  data() {
    return {
      isButtonDisplayed: false,
      displayToggleOffset: DisplayToggleOffset,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      window.scrollY > this.displayToggleOffset ?
        this.isButtonDisplayed = true : this.isButtonDisplayed = false;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
});
